<template>
  <div class="grid">
    <div class="col-12 lg:col-12 xl:col-12">
      <div class="card mb-0">
        <div class="mb-4">
          <h4>Permohonan</h4>
        </div>
        <div class="grid mb-3">
          <div class="col-6"></div>
          <div class="col-3">
            <span class="p-float-label">
              <Calendar 
                class="w-full"
                v-model="filter.tanggal_awal_permohonan" 
                dateFormat="dd-mm-yy"
                placeholder="tanggal awal"
                showButtonBar
              />
              <label for="birth_date">tanggal awal</label>
            </span>
          </div>
          <div class="col-3">
            <span class="p-float-label">
              <Calendar 
                class="w-full"
                v-model="filter.tanggal_akhir_permohonan" 
                dateFormat="dd-mm-yy"
                placeholder="tanggal akhir"
                showButtonBar
              />
              <label for="birth_date">tanggal akhir</label>
            </span>
          </div>
        </div>
        <DataTable 
          class="p-datatable-sm"
          tableStyle="min-width: 50rem" 
          :value="items" 
          v-model:filters="filters"
          @filter="onFilter($event)"
          filterDisplay="menu"
          :showFilterMatchModes="false"
          paginator 
          :rows="$store.state.pagination.row" 
          :rowsPerPageOptions="$store.state.pagination.perPage"
          lazy 
          :totalRecords="totalRecords"
          @page="onPage"
          :rowHover="true"
          responsiveLayout="scroll"
          :resizableColumns="true"
          :loading="loading"
        >
          <Column field="no" header="No" class="text-center" style="width: 0px">
            <template #body="{ index }">
              {{1 + index}}
            </template>
          </Column>
          <Column field="nama_pemohon" header="Nama Pemohon" class="" style="" :showFilterMatchModes="false" :showApplyButton="false" :showClearButton="true">
            <template #filter="{ filterModel, filterCallback }" >
              <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter f-full" placeholder="Search by name" />
            </template>
          </Column>
          <Column field="no_identitas" header="No Identitas" class="" style="" :showFilterMatchModes="false" :showApplyButton="false" :showClearButton="true">
            <template #filter="{ filterModel, filterCallback }" >
              <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter f-full" placeholder="Search by name" />
            </template>
          </Column>
          <Column field="asal_pemohon" header="Asal Pemohon" class="" style="" :showFilterMatchModes="false" :showApplyButton="false" :showClearButton="true">
            <template #filter="{ filterModel, filterCallback }" >
              <Dropdown 
                v-model="filterModel.value" 
                @change="filterCallback()" 
                :options="$store.state.data_static.asal_pemohon" 
                optionLabel="text" 
                optionValue="value" 
                placeholder="pilih asal pemohon" 
                class="w-full" 
              />
            </template>
          </Column>
          <Column field="nama_kategori" header="Kategori" class="" style="" :showFilterMatchModes="false" :showApplyButton="false" :showClearButton="true">
            <template #filter="{ filterModel, filterCallback }" >
              <Dropdown filter showClear v-model="filterModel.value" @change="filterCallback()" optionLabel="nama_kategori" optionValue="id" :options="listKategori" placeholder="pilih kategori" class="w-full" />
            </template>
          </Column>
          <Column field="nama_status_permohonan" header="Status" class="" style="" :showFilterMatchModes="false" :showApplyButton="false" :showClearButton="true">
            <template #filter="{ filterModel, filterCallback }" >
              <Dropdown 
                v-model="filterModel.value" 
                @change="filterCallback()" 
                optionLabel="text" 
                optionValue="value" 
                :options="$store.state.data_static.status_pengaduan" 
                placeholder="pilih status" 
                class="w-full" 
              />
            </template>
          </Column>
          <Column  field="nama_tanggal" header="Tanggal" class="" style=""></Column>
          <Column field="actions" header="" bodyClass="text-center" style="width: 0px">
            <template #body="{ data }">
              <div class="flex sm:flex-row">
                <div class="m-1">
                  <ModalDetail :data="data" @refresh="getData()"/>
                </div>
                <div class="m-1">
                  <ModalUpdate v-if="
                    data.status_permohonan != 0 &&
                    ((role == 'operator' && data.status_permohonan == 1) ||
                    (role == 'supervisor' && data.status_permohonan == 2) || 
                    (role == 'manajer' && data.status_permohonan == 3) ||
                    role == 'superuser' && data.status_permohonan <= 3)
                  " :data="data" @refresh="getData()"/>
                </div>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import ModalUpdate from './modalUpdate.vue'
import ModalDetail from './modalDetail.vue'
export default {
  components: {
    ModalUpdate,
    ModalDetail,
  },
  data() {
    return {
      listKategori: [],
      items: [],
      //for table
      filters: {
        nama_pemohon: '',
        no_identitas: '',
        asal_pemohon: '',
        nama_kategori: '',
        nama_status_permohonan: '',
      },
      //for data form backend
      filter: {
        tanggal_awal_permohonan: undefined,
        tanggal_akhir_permohonan: undefined,
      },
      pagination: {
        halaman: 1, 
        jumlah: this.$store.state.pagination.row
      },
      totalRecords: 100,
      loading: false,
    };
  },
  computed: {
    role(){
      return this.$store.state.login.role
    },
    data() {
      const vm = this
      return {
        ...vm.filter,
        ...vm.pagination,
      }
    }
  },
  watch: {
    data(newVal, oldVal){
      if(newVal, oldVal){
        this.getData()
      }
    }
  },
  async mounted() {
    const vm = this
    switch (vm.$route.query.type) {
      case 'belum':
        vm.filter.nama_status_permohonan = 1
        vm.filters.nama_status_permohonan = {value: 1}
        break;
    }
    vm.getData()
    vm.getDataOther()
  },
  methods: {
    onPage(e){
      const vm = this
      vm.pagination.halaman = e.page + 1
      vm.pagination.jumlah = e.rows
    },
    onFilter(e) {
      const vm = this
      vm.pagination.halaman = 1
      for (const key in e.filters) {
        vm.filter[key] = e.filters[key].value
      }
    },
    async getData(){
      const vm = this
      vm.loading = true
      let res = await vm.$axios.post('permohonan/list', {
        ...vm.data,
        tanggal_awal_permohonan: vm.filter.tanggal_awal_permohonan ? vm.$moment(vm.filter.tanggal_awal_permohonan).format('YYYY-MM-DD') : undefined,
        tanggal_akhir_permohonan: vm.filter.tanggal_akhir_permohonan ? vm.$moment(vm.filter.tanggal_akhir_permohonan).format('YYYY-MM-DD') : undefined,
        status_permohonan: vm.filter.nama_status_permohonan === 0 ? 0 : vm.filter.nama_status_permohonan || undefined,
        kategori_id: vm.filter.nama_kategori,
      })
      vm.items = []
      for (let i = 0; i < res.data.data.length; i++) {
        const x = res.data.data[i];
        x.nama_tanggal = x.tanggal_permohonan ? vm.$moment(x.tanggal_permohonan).format('LL') : '-'
        for (let u = 0; u < vm.$store.state.data_static.status_pengaduan.length; u++) {
          const y = vm.$store.state.data_static.status_pengaduan[u];
          if(y.value == x.status_permohonan) {
            x.nama_status_permohonan = y.text
            break;
          }
        }
        vm.items.push({
          ...x,
        })
      }
      vm.totalRecords = Number.parseInt(res.data.count)
      // console.log('res', res)
      // console.log('vm.items', vm.items)
      vm.loading = false
    }, 
    async getDataOther(){
      const vm = this
      let kategori = await vm.$axios.post('kategori/list')
      vm.listKategori = kategori.data.data
    },
  },
};
</script>